const initialState = {
  users: [],
};
const userRoducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_USERS":
      return { ...state, users: action.payload };
    case "DELETE_USERS":
      return (state = {
        ...state,
        users: state?.users?.filter(
          (users) => users._id !== action.payload?._id
        ),
      });
    case "UPDATE_USER_ACTIVE_INACTIVE_STATUS":
      return (state = {
        ...state,
        users: state?.users?.map((users) =>
            users._id === action.payload._id ? action?.payload : users
        ),
      });
    default:
      return state;
  }
};

export default userRoducer;
